class Option {
  constructor(
    {
      imageUrl,
      productId,    
      itemId,
      itemName,
      additionalCount,
      nowCount,
      stockCount
    }
  ) {
    this.imageUrl = imageUrl
    this.productId = productId
    this.itemId = itemId
    this.itemName = itemName
    this.additionalCount = additionalCount
    this.stockCount = stockCount < 0 ? 0 : stockCount
    this.nowCount = nowCount * additionalCount > stockCount
      ? stockCount
      : nowCount * additionalCount
    this.overflow = false

    this.checkIntersectQuantity(nowCount)
  }

  checkIntersectQuantity(quantity) {
    this.overflow = quantity * this.additionalCount > this.stockCount
  }

  addQuantity(quantity) {
    if (this.overflow) {
      this.nowCount = this.stockCount
      return
    }

    this.nowCount = quantity * this.additionalCount
  }

  subQuantity(quantity) {
    if (this.overflow) return
    if (this.nowCount <= 1) return

    this.nowCount = quantity * this.additionalCount
    if (this.nowCount < 1) this.nowCount = 1
  }

  getImage() {
    return this.imageUrl
  }

  getProductId() {
    return this.productId
  }

  getItemId() {
    return this.itemId
  }

  getItemName() {
    return this.itemName
  }

  getMaxCount() {
    return this.maxCount
  }

  getNowCount() {
    return this.nowCount
  }

  getMinCount() {
    return 1
  }

  getStockCount() {
    return this.stockCount
  }

  getOverflow() {
    return this.overflow
  }

  isVisible() {
    return this.stockCount > 0
  }
}

export default Option
